import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useChatStore } from '../stores/chatStore';
import { useAuthStore } from '../stores/authStore';

const TABS = [
  { path: '/', label: 'Chat', icon: '💬' },
  { path: '/memories', label: 'Memórias', icon: '🧠' },
  { path: '/followups', label: 'Follow-ups', icon: '📋' },
  { path: '/reminders', label: 'Lembretes', icon: '⏰' },
];

export function Layout() {
  const location = useLocation();
  const { createConversation, selectConversation } = useChatStore();
  useAuthStore();
  const [showNewChat, setShowNewChat] = useState(false);

  const handleNewChat = async () => {
    const id = await createConversation();
    await selectConversation(id);
    setShowNewChat(false);
  };

  return (
    <div className="app-shell">
      <header style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0.75rem 1rem',
        background: 'var(--bg-elevated)',
        borderBottom: '1px solid var(--border)',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}>
        <h1 style={{ fontSize: '1.125rem', fontWeight: 700 }}>Agente Gerencial</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <NavLink to="/settings" className="btn btn-ghost btn-sm" aria-label="Configurações" title="Configurações" style={{ minWidth: '44px', minHeight: '44px' }}>
            ⚙️
          </NavLink>
        <button
          onClick={() => setShowNewChat(true)}
          className="btn btn-primary btn-sm"
          style={{ display: location.pathname === '/' ? 'flex' : 'none' }}
        >
          + Nova conversa
        </button>
        </div>
      </header>

      <main className="app-main">
        <Outlet />
      </main>

      <nav className="tabs app-tabs" aria-label="Navegação principal">
        {TABS.map(({ path, label, icon }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) => `tab ${isActive ? 'active' : ''}`}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.375rem' }}
          >
            <span>{icon}</span>
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      {showNewChat && (
        <div className="modal-backdrop" onClick={() => setShowNewChat(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h3 style={{ marginBottom: '1rem' }}>Nova conversa</h3>
            <p style={{ color: 'var(--fg-muted)', marginBottom: '1.5rem', fontSize: '0.875rem' }}>
              Inicie uma nova conversa com o agente.
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
              <button className="btn btn-secondary btn-sm" onClick={() => setShowNewChat(false)}>Cancelar</button>
              <button className="btn btn-primary btn-sm" onClick={handleNewChat}>Criar</button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .modal-backdrop {
          position: fixed; inset: 0; background: rgba(0,0,0,0.6);
          display: flex; align-items: center; justify-content: center;
          z-index: 200; padding: 1rem;
        }
        .modal {
          background: var(--bg-elevated); border: 1px solid var(--border);
          border-radius: var(--radius); padding: 1.5rem; width: 100%; max-width: 400px;
        }
      `}</style>
    </div>
  );
}
